import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Story } from "@/components/site/Story";
import { Menu } from "@/components/site/Menu";
import { Shakes } from "@/components/site/Shakes";
import { WhyLove } from "@/components/site/WhyLove";
import { Locations } from "@/components/site/Locations";
import { Gallery } from "@/components/site/Gallery";
import { InstagramFeed } from "@/components/site/InstagramFeed";
import { Reviews } from "@/components/site/Reviews";
import { Footer } from "@/components/site/Footer";
import { InquiryWidget } from "@/components/site/InquiryWidget";
import { OrderModal } from "@/components/site/OrderModal";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search.includes("nolenis")) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App bg-[#FFF7F0] text-[#2A1620] antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Story />
        <Menu />
        <Shakes />
        <WhyLove />
        <Locations />
        <Gallery />
        <InstagramFeed />
        <Reviews />
      </main>
      <Footer />
      <InquiryWidget />
      <OrderModal />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
